import { FEATURE_FLAGS_MODULES } from 'src/featureFlags/FeatureFlags.models';
import { useHasFeatureFlag } from 'src/featureFlags/useHasFeatureFlag';
import { Actions, Subjects } from 'src/permissions/ability';
import { useAbility } from 'src/permissions/hooks/useAbility';

export const AUDIT_TRAIL_FOR_CUSTOMERS_FLAG = 'AuditTrailForCustomers';

export const useAuditTrailAvailable = () => {
  const ability = useAbility();
  const hasPermission = ability.can(Actions.read, Subjects.auditTrails);
  const isInternalUser = ability.can(Actions.read, Subjects.internalData);
  const customerAuditTrailEnabled = useHasFeatureFlag(
    AUDIT_TRAIL_FOR_CUSTOMERS_FLAG,
    FEATURE_FLAGS_MODULES.AUDIT_TRAIL,
  );

  return hasPermission && (isInternalUser || customerAuditTrailEnabled);
};
